import { useNavigate } from "react-router-dom";
import { getColumns } from "./Columns";
import Pagination from "./Pagination";
import { Table } from "../Sessions/Table";

function SessionSection({ title, data, totalCount, searchPlaceholder,
	currentPage, setCurrentPage, searchTerm, setSearchTerm, pageSize, showStudentName, showLanguage, showTutor }) {
	const navigate = useNavigate();

	return (
		<div className="row wow fadeInUp" data-wow-delay="1.5s">
			<div className="col-12">
				<div className="card mt-0">
					<div className="card-header py-3 px-3 d-flex justify-content-between align-items-center">
						<h5 className="heading">{title}</h5>
					</div>
					<div className="card-body p-0 ">
						<div className="bg-white">
							<div className="page-title flex-wrap mb-0">
								<div className="input-group search-area mb-md-0 ml-3">
									<input type="text" className="form-control ps-4" placeholder={searchPlaceholder || "Search here..."}
										value={searchTerm} onChange={(e) => {
											setCurrentPage(1);
											setSearchTerm(e.target.value)
										}} />
								</div>
							</div>

							{data && (
								<Table data={data} columns={getColumns(data, showStudentName, showLanguage, showTutor)} pageSize={pageSize}
									filterConfig={[]} buttonConfig={[]} searchableColumns={[]}
									onRowClick={(item) => navigate(`/sessions/sessionDetails/${item.sessionId}`)}
								/>
							)}

							<Pagination currentPage={currentPage} totalCount={totalCount}
								pageSize={pageSize} onPageChange={setCurrentPage} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SessionSection